import axios from 'axios'

//新版==================================================================
//首页-概览
export function newsummary(data) {
  return axios({
    method: 'get',
    url: '/api/admin/dashboard/summary',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//首页-趋势
export function newtrends(data) {
  return axios({
    method: 'get',
    url: '/api/admin/dashboard/trends',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//首页-系统更新日志
export function newchangelog(data) {
  return axios({
    method: 'get',
    url: '/api/admin/dashboard/changelogs',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//账号密码登录
export function newlogin(data) {
  return axios({
    method: 'post',
    url:'/api/auth/v2/login_platform_admin',
    data:data
  })
}
//获取主体
export function newgetcomp(data) {
  return axios({
    method: 'get',
    url:'/api/platform/admin_corpsx',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取主体2
export function newgetcomp2(data) {
  return axios({
    method: 'get',
    url:'/api/platform_employee/corp/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//进入主体
export function newentercomp(data) {
  return axios({
    method: 'post',
    url:'/api/auth/login_with_empidx',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//退出登录
export function newoutlogin(data) {
  return axios({
    method: 'post',
    url:'/api/auth/logout',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//用户信息
export function newauth(data) {
  return axios({
    method: 'get',
    url:'/api/auth/v2/me',
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

export function newsendfriend(data) {
  return axios({
    method: 'post',
    url: '/api/moment/send',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
export function newsendfriendv2(data) {
  return axios({
    method: 'post',
    url: '/api/moment/send/new',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

export function newsendfrienddetail(data) {
  return axios({
    method: 'post',
    url: '/api/moment/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

export function newsendfriendlist(data) {
  return axios({
    method: 'post',
    url: '/api/send/moment/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

export function newdelfriendcircle(data) {
  return axios({
    method: 'post',
    url: '/api/delete/moment',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

export function newgetpeo(data) {
  return axios({
    method: 'get',
    url: '/api/internal-user/add/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//添加方式
export function newgetway(data) {
  return axios({
    method: 'get',
    url: '/api/external-contact/add_way/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//来源渠道
export function newgetsource(data) {
  return axios({
    method: 'get',
    url: '/api/external-contact/source/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//加好友
export function newaddfriend(data) {
  return axios({
    method: 'post',
    url: '/api/add/fans/task',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//加好友列表
export function newaddfriendlist(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除加好友
export function newdelfriend(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//终止加好友
export function newstopfriend(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/stop',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//好友-导出
export function newfriendexport(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//好友-导出申请记录
export function newfriendexportask(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/add/friend/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//好友-详情
export function newfriendadddetail(data) {
  return axios({
    method: 'post',
    url: '/api/fans/task/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//敢探号人群
export function newgetgth(data) {
  return axios({
    method: 'post',
    url: '/api/crowd/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//新增欢迎语
export function newaddwelcome(data) {
  return axios({
    method: 'post',
    url: '/api/add/welcome/content',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//新增欢迎语列表
export function newwelcomelist(data) {
  return axios({
    method: 'post',
    url: '/api/welcome/content/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除欢迎语列表
export function newdelwelcome(data) {
  return axios({
    method: 'post',
    url: '/api/del/welcome/content',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//欢迎语详情
export function newwelcomedetail(data) {
  return axios({
    method: 'post',
    url: '/api/welcome/content/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}


//好友验证语列表
export function newfriendtestlist(data) {
  return axios({
    method: 'post',
    url: '/api/verify/content/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//好友验证语新增和编辑
export function newfriendtestadd(data) {
  return axios({
    method: 'post',
    url: '/api/add/verify/content',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//好友验证语删除
export function newfriendtestdel(data) {
  return axios({
    method: 'post',
    url: '/api/del/verify/content',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}


//设备列表
export function newphonelist(data) {
  return axios({
    method: 'get',
    url:'/api/device/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//添加设备
export function newaddphone(data) {
  return axios({
    method: 'post',
    url: '/api/device/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//设备详情
export function newphonedetail(data) {
  return axios({
    method: 'get',
    url:'/api/device/info',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改设备
export function neweditphone(data) {
  return axios({
    method: 'post',
    url: '/api/device/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改设备（简化）
export function newupdatesimple(data) {
  return axios({
    method: 'post',
    url: '/api/device/update_simple',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除设备
export function newdelphone(data) {
  return axios({
    method: 'post',
    url: '/api/device/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//术语列表
export function newmsglist(data) {
  return axios({
    method: 'get',
    url:'/api/script/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//术语创建
export function newmsgadd(data) {
  return axios({
    method: 'post',
    url:'/api/script/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//术语编辑
export function neweditmsg(data) {
  return axios({
    method: 'post',
    url:'/api/script/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//术语删除
export function newdelmsg(data) {
  return axios({
    method: 'post',
    url:'/api/script/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//创建关键词
export function newcreatekey(data) {
  return axios({
    method: 'post',
    url:'/api/keyword-reply/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取关键词列表
export function newkeylist(data) {
  return axios({
    method: 'get',
    url:'/api/keyword-reply/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//编辑关键词列表
export function neweditkey(data) {
  return axios({
    method: 'post',
    url:'/api/keyword-reply/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除关键词列表
export function newdelkey(data) {
  return axios({
    method: 'post',
    url:'/api/keyword-reply/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}


//获取回复模版列表
export function newgetcallbacklist(data) {
  return axios({
    method: 'get',
    url:'/api/reply-template/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//创建回复列表
export function newcreatecallback(data) {
  return axios({
    method: 'post',
    url:'/api/reply-template/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改回复列表
export function neweditcallback(data) {
  return axios({
    method: 'post',
    url:'/api/reply-template/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除回复列表
export function newdelcallback(data) {
  return axios({
    method: 'post',
    url:'/api/reply-template/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}


//获取员工列表
export function newgetkflist(data) {
  return axios({
    method: 'get',
    url:'/api/platform_employee/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//创建员工
export function newcreatekf(data) {
  return axios({
    method: 'post',
    url:'/api/platform_employee/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//更新员工
export function neweditkf(data) {
  return axios({
    method: 'put',
    url:'/api/platform_employee/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除员工
export function newdelkf(data) {
  return axios({
    method: 'delete',
    url:'/api/platform_employee/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取内部成员列表
export function newgetneilist(data) {
  return axios({
    method: 'post',
    url:'/api/device/reception/seats',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取内部成员列表（新接口）
export function newgetneilistnew(data) {
  return axios({
    method: 'post',
    url:'/api/device/reception/seats_new',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取坐席列表v2
export function newgetneilistv2(data) {
  return axios({
    method: 'post',
    url:'/api/device/reception/seats_v2',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//更改坐席企微账号启用状态
export function newchgseatstatus(data) {
  return axios({
    method: 'post',
    url:'/api/device/reception/seat/status',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取单向客户数量
export function newgetonewaycustomer(data) {
  return axios({
    method: 'post',
    url:'/api/wework/one_way_customer/pull_customers',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取单向客户数量（新接口）
export function newgetonewaycustomernew(data) {
  return axios({
    method: 'post',
    url:'/api/wework/one_way_customer/pull_customers_new',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户继承创建（inheritance_type：1 在职继承 2 离职继承）
export function newcreateinheritance(data) {
  return axios({
    method: 'post',
    url: '/api/customer-inheritance/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//删除坐席
export function newdeleteseat(data) {
  return axios({
    method: 'post',
    url: '/api/device/delete_seat',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取内部成员列表
export function neweditpwd(data) {
  return axios({
    method: 'put',
    url:'/api/platform_employee/update/password',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}



//获取商城
export function newgetshop(data) {
  return axios({
    method: 'post',
    url:'/api/marketing/statistics',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取商城
export function newgettongji(data) {
  return axios({
    method: 'post',
    url:'/api/marketing/date/statistics',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//查看全部小程序导出
export function newcheckexportweapp(data) {
  return axios({
    method: 'post',
    url: '/api/statistics/get/export/all',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//小程序导出
export function newexportweapp(data) {
  return axios({
    method: 'post',
    url: '/api/statistics/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//小程序导出
export function newexporttongji(data) {
  return axios({
    method: 'post',
    url: '/api/statistics/date/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//查询感叹号人群列表
export function newgetgthlist(data) {
  return axios({
    method: 'get',
    url: '/api/call/task/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//查询标签列表
export function newgettaglist(data) {
  return axios({
    method: 'get',
    url: '/api/plat/tag/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//保存标签组（标签增删改一次提交）
export function newcatesave(data) {
  return axios({
    method: 'post',
    url: '/api/plat/tag/cate/save',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//添加标签单个
export function newaddtagitem(data) {
  return axios({
    method: 'post',
    url: '/api/plat/tag/add',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除标签组
export function newdelgroup(data) {
  return axios({
    method: 'post',
    url: '/api/plat/tag/cate/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//同步标签
export function newtonggroup(data) {
  return axios({
    method: 'get',
    url: '/api/tag/qw/sync',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//同步企微标签到本地
export function newtongcompgroup(data) {
  return axios({
    method: 'get',
    url: '/api/tag/local/sync',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//渠道类别添加
export function neweaddqd(data) {
  return axios({
    method: 'post',
    url: '/api/channelType/add',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道类别列表
export function newqdlist(data) {
  return axios({
    method: 'get',
    url: '/api/channelType/list',
    params:data,  
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道类别编辑
export function neweditqd(data) {
  return axios({
    method: 'post',
    url: '/api/channelType/edit',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道类别删除
export function newdelqd(data) {
  return axios({
    method: 'get',
    url: '/api/channelType/delete',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//渠道新建
export function newaddqudao(data) {
  return axios({
    method: 'post',
    url: '/api/plat/channel/add',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道编辑
export function neweditqudao(data) {
  return axios({
    method: 'post',
    url: '/api/plat/channel/edit',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道列表
export function newqudaolist(data) {
  return axios({
    method: 'get',
    url: '/api/plat/channel/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//渠道类别删除
export function newdelqudao(data) {
  return axios({
    method: 'get',
    url: '/api/plat/channel/delete',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户管理列表
export function newekhlist(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/plat/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户管理详情
export function newekhdetail(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/detail',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户列表导出
export function newekhlistexport(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客户列表导出
export function newekhexport(data) {
  return axios({
    method: 'post',
    url: '/api/export/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改客户标签
export function newechangekhtag(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/edit/plat/tag',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//接待坐席列表
export function newgetzxlist(data) {
  return axios({
    method: 'get',
    url: '/api/device/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//标签分类
export function newgetbqtypev2(data) {
  return axios({
    method: 'get',
    url: '/api/plat/tag/cate/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户标签
export function newgetbqlistv2(data) {
  return axios({
    method: 'get',
    url: '/api/plat/tag/info/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//操作员列表
export function newgetczlist(data) {
  return axios({
    method: 'get',
    url: '/api/platform_employee/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//外部联系人列表
export function newgetwblist(data) {
  return axios({
    method: 'post',
    url: '/api/session_history/contact/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//会话历史统计
export function newsessionstatistics(data) {
  return axios({
    method: 'post',
    url: '/api/session_history/statistics',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//会话历史列表（新版）
export function newsessionlist(data) {
  return axios({
    method: 'post',
    url: '/api/session_history/contact/list/new',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//会话消息列表
export function newgetchatmsglist(data) {
  return axios({
    method: 'get',
    url: '/api/session_history/messages',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客户基础信息（管理员）
export function newgetplatphoneadmin(data) {
  return axios({
    method: 'get',
    url: '/api/external-contact/get/plat/phone/for/admin',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//号卡订单信息（手机号获取详情订单）
export function newgetorderinfo(data) {
  return axios({
    method: 'post',
    url: '/api/web/wechat/mini/get/order/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//体育订单信息
export function newgetsportorder(data) {
  return axios({
    method: 'post',
    url: '/api/order/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码--渠道列表
export function newgethmqdlist(data) {
  return axios({
    method: 'get',
    url: '/api/plat/channel/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码--成员列表
export function newgethmcylist(data) {
  return axios({
    method: 'get',
    url: '/api/device/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码-创建
export function newgethmcreate(data) {
  return axios({
    method: 'post',
    url: '/api/channel_code/store',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//新-活码-创建
export function newgethmcreatev2(data) {
  return axios({
    method: 'post',
    url: '/api/channel_code/store/new',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码-列表
export function newgethmlist(data) {
  return axios({
    method: 'post',
    url: '/api/channel_code/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码-删除
export function newgethmdel(data) {
  return axios({
    method: 'DELETE',
    url: '/api/channel_code/delete',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码--详情
export function newgethdetail(data) {
  return axios({
    method: 'get',
    url: '/api/channel_code/detail',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}


//计算数量
export function newgetnums(data) {
  return axios({
    method: 'post',
    url: '/api/bulk-message/task/count',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//创建群发
export function newcreateall(data) {
  return axios({
    method: 'post',
    url: '/api/bulk-message/task/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取群发列表
export function newgetallsendlist(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/task/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//发送限时获取
export function newgetallsendtime(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/setting/info',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//发送限时设置
export function neweditallsendtime(data) {
  return axios({
    method: 'post',
    url: '/api/bulk-message/setting/save',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//删除群发
export function newdelallsendtime(data) {
  return axios({
    method: 'post',
    url: '/api/bulk-message/task/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取群发详情
export function newgetallsenditem(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/task/info',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//获取群发人
export function newgetallsenduser(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/task/contacts',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//导出群发任务联系人明细
export function newexportallsenduser(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/task/contacts/export',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//批量导出群发任务联系人明细
export function newexportallsenduserbatch(data) {
  return axios({
    method: 'get',
    url: '/api/bulk-message/task/contacts/export-batch',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取绩效时间列表
export function newgetjxtime(data) {
  return axios({
    method: 'get',
    url: '/api/customer/performance/time_ranges',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客服绩效列表
export function newgetjxlist(data) {
  return axios({
    method: 'post',
    url: '/api/customer/performance/stats',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客服绩效导出
export function newexportjxlist(data) {
  return axios({
    method: 'post',
    url: '/api/customer/performance/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客服绩效-导出有效会话明细
export function newexportvalidjxlist(data) {
  return axios({
    method: 'post',
    url: '/api/customer/performance/valid_sessions/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//数据统计列表
export function newgetdatatj(data) {
  return axios({
    method: 'get',
    url: '/api/data/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//数据统计列表
export function newgetdatatjall(data) {
  return axios({
    method: 'get',
    url: '/api/data/statistic2',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//数据统计列表
export function newgetdatatjtop(data) {
  return axios({
    method: 'get',
    url: '/api/data/statistic',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//数据统计导出
export function newexportdata(data) {
  return axios({
    method: 'get',
    url: '/api/data/export',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//发送记录
export function newsendlist(data) {
  return axios({
    method: 'post',
    url: '/api/moment/send/log',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//重新发送
export function newrepsend(data) {
  return axios({
    method: 'post',
    url: '/api/moment/resend',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//终止发送朋友圈
export function newstopsend(data) {
  return axios({
    method: 'post',
    url: '/api/cancel/moment',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//平台信息
export function newcompinfo(data) {
  return axios({
    method: 'get',
    url: '/api/platform/info',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}



//账号-修改密码
export function neweditpassword(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/password/change',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//账号-修改手机号
export function neweditphonecom(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/phone/change',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//账号-修改敢探号信息
export function neweditght(data) {
  return axios({
    method: 'post',
    url: '/api/platform/edit/platform/info',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取我的铭文
export function newcompsec(data) {
  return axios({
    method: 'get',
    url: '/api/platform/user/info/decrypt',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//账号-新增主体
export function newaddcomp(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/wework/store/first',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//账号-编辑主体
export function neweditcomp(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/wework/store',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//账号-获取主体列表
export function newgetcomplist(data) {
  return axios({
    method: 'get',
    url: '/api/platform_employee/wework/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//AIAgent存储
export function newcreateai(data) {
  return axios({
    method: 'post',
    url: '/api/ai_agent/store',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//AIAgent存储-详情
export function newdetailai(data) {
  return axios({
    method: 'get',
    url: '/api/ai_agent/details',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//知识库-列表
export function newgetkonw(data) {
  return axios({
    method: 'get',
    url: '/api/ai_agent/knowledge/file_list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//知识库-列表-删除
export function newdelkonw(data) {
  return axios({
    method: 'DELETE',
    url: '/api/ai_agent/knowledge/file_delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//注册账号
export function newcreateuser(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/register',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//发送短信
export function newsendsms(data) {
  return axios({
    method: 'post',
    url: '/api/common/sms/send',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//找回账号
export function newfinduser(data) {
  return axios({
    method: 'get',
    url: '/api/platform_employee/search/info',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改密码
export function neweditforgetpwd(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/password/reset',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//修改 ai 回复
export function neweditaireply(data) {
  return axios({
    method: 'put',
    url: '/api/platform_employee/update/agent_switch',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取知识库列表
export function newgetkonwlist(data) {
  return axios({
    method: 'get',
    url: '/api/ai_agent/knowledge/third/files/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//选择知识库
export function newselectkonw(data) {
  return axios({
    method: 'post',
    url: '/api/ai_agent/knowledge/files/select',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//智能体列表
export function newgetagentlist(data) {
  return axios({
    method: 'get',
    url: '/api/ai_agent/v2/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//选择智能体
export function newchooseagent(data) {
  return axios({
    method: 'post',
    url: '/api/ai_agent/v2/binding',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//新版智能体列表（AI Wing）
export function newgetaiwinglist(data) {
  return axios({
    method: 'get',
    url: '/api/ai_agent/v3/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//新版智能体绑定（AI Wing）
export function newchooseaiwing(data) {
  return axios({
    method: 'post',
    url: '/api/ai_agent/v3/binding',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客服临时会话自动回复
export function newautoreply(data) {
  return axios({
    method: 'post',
    url: '/api/platform_employee/update/ephemeral_switch',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//活码数据
export function newgethmdata(data) {
  return axios({
    method: 'post',
    url: '/api/channel_code/package/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//二级联动
export function newgetcomppeo(data) {
  return axios({
    method: 'get',
    url: '/api/device/list/new',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//客户转化列表
export function newgetmanchange(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/transfer/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//客户转化列表-下载
export function newgetmanchangeexport(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/transfer/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//平台坐席列表-带坐席选择状态
export function newgetcompandacc(data) {
  return axios({
    method: 'get',
    url: '/api/ai-offline-reply-config/corp-seats-selected',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//配置 ai 离线回复
export function neweditcompandaccoutline(data) {
  return axios({
    method: 'post',
    url: '/api/ai-offline-reply-config/save',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取 ai 离线回复
export function newgetcompandaccoutline(data) {
  return axios({
    method: 'get',
    url: '/api/ai-offline-reply-config/query',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//跳转商城 token
export function newgetshoptoken(data) {
  return axios({
    method: 'post',
    url: '/api/rocky/account-token',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}
//实时预览
export function newgetnowdata(data) {
  return axios({
    method: 'get',
    url: '/api/admin/dashboard/realtime',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//获取维度元数据
export function newgetcirclekey(data) {
  return axios({
    method: 'get',
    url: '/api/audience/dimensions',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//保存人群（智能圈选）
export function newcreatecircle(data) {
  return axios({
    method: 'post',
    url: '/api/audience/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-人群列表
export function newgetcirclelist(data) {
  return axios({
    method: 'get',
    url: '/api/audience/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-编辑人群（修改人群名称/人群分类）
export function newupdatecircle(data) {
  return axios({
    method: 'post',
    url: '/api/audience/update',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-删除人群
export function newdeletecircle(data) {
  return axios({
    method: 'post',
    url: '/api/audience/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-查看人群的人员列表（/api/audience/members?id=&page=&page_size=&keyword=）
export function newgetcirclemembers(data) {
  return axios({
    method: 'get',
    url: '/api/audience/members',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-重新计算（POST /api/audience/recalculate?id=）
export function newrecalculatecircle(data) {
  return axios({
    method: 'post',
    url: '/api/audience/recalculate',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-人群成员导出（POST /api/audience/export，仅已完成(2)状态可导出，成功返回 export_task_id，在导出列表 type=2 中下载）
export function newaudienceexport(data) {
  return axios({
    method: 'post',
    url: '/api/audience/export',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群管理-名单导入创建人群（POST /api/audience/import，values 每行 {relation_id, phone}；模板两列：手机号 / 好友关系ID，每行至少填一列）
export function newimportcircle(data) {
  return axios({
    method: 'post',
    url: '/api/audience/import',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-实时计算多人群并集覆盖人数（POST /api/crowd-ops/task/cover-count，audience_ids[]）
export function newcrowdopscount(data) {
  return axios({
    method: 'post',
    url: '/api/crowd-ops/task/cover-count',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-创建任务（POST /api/crowd-ops/task/create）
export function newcreatecrowdops(data) {
  return axios({
    method: 'post',
    url: '/api/crowd-ops/task/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-保存草稿（POST /api/crowd-ops/task/draft，允许配置不完整）
export function newsavecrowdopsdraft(data) {
  return axios({
    method: 'post',
    url: '/api/crowd-ops/task/draft',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-任务列表（GET /api/crowd-ops/task/list）
export function newgetcrowdopslist(data) {
  return axios({
    method: 'get',
    url: '/api/crowd-ops/task/list',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-KPI 统计（GET /api/crowd-ops/task/stats）
export function newgetcrowdopsstats(data) {
  return axios({
    method: 'get',
    url: '/api/crowd-ops/task/stats',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-任务详情（GET /api/crowd-ops/task/detail?id=）
export function newgetcrowdopsdetail(data) {
  return axios({
    method: 'get',
    url: '/api/crowd-ops/task/detail',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-暂停任务（POST /api/crowd-ops/task/pause）
export function newpausecrowdops(data) {
  return axios({
    method: 'post',
    url: '/api/crowd-ops/task/pause',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//人群运营-继续任务（POST /api/crowd-ops/task/resume）
export function newresumecrowdops(data) {
  return axios({
    method: 'post',
    url: '/api/crowd-ops/task/resume',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//通用图片上传（POST /api/common/upload，FormData 字段 file；返回 data.url）
export function newuploadimg(file) {
  const form = new FormData()
  form.append('file', file)
  return axios({
    method: 'post',
    url: '/api/common/upload',
    data: form,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken"),
      'Content-Type': 'multipart/form-data'
    }
  })
}

//旧版==================================================================

//获取微信登记第三方应用秘钥
export function getmy(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcUserKf/agentConfig',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//获取企业code
export function getcompcode(url) {
  return axios({
    method: 'get',
    url: url+'/work/bcAuthCorpInfo/listAll',
  })
}

//扫码后获取token
export function gettoken(url,data) {
    return axios({
      method: 'get',
      url: url+'/work/bcTicket/wechat_login',
      params:data
    })
}
//账号密码登录
export function login(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTicket/login',
    params:data
  })
}
//绑定手机号
export function bindphone(url,data) {
  return axios({
    method: 'post',
    url: url+'/sys/user/updatePhone',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
// ===== 以下 work/bcDepartment* 老接口已废弃，统一注释（保留代码便于回溯） =====
//部门列表
// export function department(url,data) {
//   return axios({
//     method: 'get',
//     url: url+'/work/bcDepartment/departmentList',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//同步部门列表
// export function nowdepartment(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartment/updateDapartment',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//同步成员
// export function nowusers(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartmentUser/getAllUsers',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//人员列表-编辑
// export function peolistedit(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartmentUser/edit',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//人员列表-分页列表查询
// export function peolist(url,data) {
//   return axios({
//     method: 'get',
//     url: url+'/work/bcDepartmentUser/list',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
// ===== 以上 work/bcDepartment* 老接口已废弃 =====

//标签组-分页列表查询
export function bqlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcTagGroup/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//创建标签组
export function addbqgroup(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/addGroup',
    data:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//编辑标签组
export function changebqgroup(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/editGroup',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//删除标签组
export function delbqgroup(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/deleteGroup',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//创建标签
export function addbq(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/addTag',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//编辑标签
export function changebq(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/editTag',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//删除标签
export function delbq(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/deleteTag',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-分页列表查询
export function qdtypelist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcContantWayCategory/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-添加
export function addqdtype(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWayCategory/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//渠道类别管理-编辑
export function changeqdtype(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWayCategory/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-删除
export function delqdtype(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWayCategory/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道管理-分页列表查询
export function qdmlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcContantWay/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-新增
export function addqdm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWay/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-新增
export function changeqdm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWay/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道类别管理-删除
export function delqdm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantWay/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//获取所有成员--下拉列表（已废弃）
// export function allpeoselect(url,data) {
//   return axios({
//     method: 'get',
//     url: url+'/work/bcDepartmentUser/personList',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }

//渠道活码-添加
export function addqdhm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantQr/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道活码-编辑
export function changeqdhm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantQr/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道活码-分页列表查询
export function qdhmlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcContantQr/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道活码-删除
export function delqdhm(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcContantQr/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//渠道活码-详情
export function detailqdhm(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcContantQr/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}



//同步客户
export function tbkh(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcCompanyCustomer/getAllCustomer',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//企业客户管理-分页列表查询
export function khlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcCompanyCustomer/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//企业客户管理-分页列表查询
export function khdetail(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcCompanyCustomer/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//客服用户表-分页列表查询
export function kflist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcCompanyDevice/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//客服用户表-批量增加标签
export function pladd(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagCustomer/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服用户表-批量删除标签
export function pldel(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagCustomer/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//添加朋友圈
export function addfriend(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcSendMoment/send',
    data:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//同步标签
export function sametagfunc(url) {
  return axios({
    method: 'post',
    url: url+'/work/bcTagGroup/corpTag',
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//群发消息
export function sendall(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblTimetask/add',
    data:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
} 

//发送消息任务-分页列表查询
export function allsendlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblTimetask/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//发送消息任务-通过id删除
export function Delsendlist(url,data) {
  return axios({
    method: 'delete',
    url: url+'/work/tblTimetask/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//发送消息任务-通过id查询
export function allsenditem(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblTimetask/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//发送消息子任务-分页列表查询
export function itemsendlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcSendMessageLog/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//获得预估发送人数
export function checknum(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblTimetask/getEstimateNum',
    data:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//发送限时-添加或者编辑
export function xstimeadd(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblTimetask/timeAdd',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//发送限时-通过id查询
export function xstimeedit(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblTimetask/queryByCorpId',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//欢迎语模版-新增
export function AddWelcome(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddWelcome/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//欢迎语模版-编辑
export function EditWelcome(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddWelcome/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//欢迎语模版-列表
export function WelcomeList(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddWelcome/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//欢迎语模版-删除
export function DelWelcome(url,data) {
  return axios({
    method: 'delete',
    url: url+'/work/bcAddWelcome/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//欢迎语模版-通过id查询
export function checkWelcome(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddWelcome/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版管理-添加
export function AddTest(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddSms/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版管理-列表
export function Testlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddSms/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版-删除
export function DelTest(url,data) {
  return axios({
    method: 'delete',
    url: url+'/work/bcAddSms/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版-批量删除
export function DelTestAll(url,data) {
  return axios({
    method: 'delete',
    url: url+'/work/bcAddSms/deleteBatch',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版-编辑
export function EditTest(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddSms/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//验证语模版管理-通过id查询
export function CheckTest(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddSms/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//加好友任务-添加
export function addfriendphone(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddFriendTask/add',
    data:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//加好友任务-分页列表查询
export function friendlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//加好友任务-id删除
export function delfriendlist(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddFriendTask/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//加好友任务-详情
export function frienddetail(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//导入数据
export function drlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/queryImportById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//申请记录
export function recordlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/queryRecordById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//终止
export function stoplist(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAddFriendTask/interruptTask',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//查询感叹号人群列表
export function getgthlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/findGTHInfo',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//查询短信任务列表
export function getgthmsglist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAddFriendTask/findGTHSmsList',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//查询感叹号人群列表
export function getcirclelist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcSendMoment/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//朋友圈-通过id删除
export function delcircle(url,data) {
  return axios({
    method: 'DELETE',
    url: url+'/work/bcSendMoment/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//朋友圈回显
export function getcircle(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcSendMoment/queryById',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//客服账号管理-分页列表查询
export function getacclist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblAccountinfo/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//客服账号管理-通过id删除
export function delacc(url,data) {
  return axios({
    method: 'DELETE',
    url: url+'/work/tblAccountinfo/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//客服账号管理-添加
export function addacc(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblAccountinfo/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服账号管理-编辑
export function editacc(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblAccountinfo/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//设备管理-分页列表查询
export function getphonelist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblWxAccountinfo/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//设备管理-添加
export function addphone(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblWxAccountinfo/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//设备管理-编辑
export function editphone(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblWxAccountinfo/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//设备管理-通过id删除
export function delphone(url,data) {
  return axios({
    method: 'DELETE',
    url: url+'/work/tblWxAccountinfo/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//属于分类-分页列表查询
export function gettypelist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/tblCommontermtype/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//属于分类-添加
export function addtype(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblCommontermtype/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//属于分类-编辑
export function edittype(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/tblCommontermtype/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//属于分类-通过id删除
export function deltype(url,data) {
  return axios({
    method: 'DELETE',
    url: url+'/work/tblCommontermtype/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服术语-分页列表查询
export function getcylist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/quickPhrases/pageList',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服术语-添加
export function addcy(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/quickPhrases/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服术语-编辑
export function editcy(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/quickPhrases/update',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服术语-通过id删除
export function delcy(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/quickPhrases/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客户数据统计-//获取抬头4个总数接口 
export function getfourdata(url) {
  return axios({
    method: 'get',
    url: url+'/work/bcCompanyCustomer/getCustomerStatisticsNum',
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客户数据统计--统计分页列表查询（已废弃）
// export function gettjlist(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartmentUser/departmentUserPageList',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//客户数据统计--人员列表-统计合计数量查询（已废弃）
// export function gettjnum(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartmentUser/getDepartmentUserNum',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//导出-统计合计数量查询（已废弃）
// export function exportallnum(url,data) {
//   return axios({
//     method: 'post',
//     url: url+'/work/bcDepartmentUser/departmentUserExportXls',
//     params:data,
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }
//聊天统计合计数量查询
export function chattongji(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcCompanyCustomer/performanceManagementList',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}
//客服列表（已废弃）
// export function chatkflist(url,data) {
//   return axios({
//     method: 'get',
//     url: url+'/work/bcDepartmentUser/accountinfoList',
//     headers: {
//       'token': $cookies.get("fanstoken")
//     }
//   })
// }

//客户列表
export function conslist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/awbSession/list2',
    headers: {
      'token': $cookies.get("fanstoken")
    },
    params:data,
  })
}


//聊天内容
export function chatcon(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/awbSession/queryById',
    headers: {
      'token': $cookies.get("fanstoken")
    },
    params:data,
  })
}

//导出
export function khdaochu(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcCompanyCustomer/exportXlsNew',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//聊天内容
export function khdownlist(url) {
  return axios({
    method: 'get',
    url: url+'/work/bcExportTask/list',
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//发送结果-删除结果
export function sendrestlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcSendMomentRecord/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//重新操作
export function repset(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcSendMomentRecord/reset',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//售前和离线回复模版列表
export function onoroutline(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcAutoModel/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//售前和离线回复模版列表-编辑
export function editonoroutline(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcAutoModel/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//关键词回复列表
export function keylist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcKeyWord/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}


//售前和离线回复模版列表-删除
export function delkeyword(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcKeyWord/delete',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//售前和离线回复模版列表-新增关键词
export function addkeyword(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcKeyWord/add',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//售前和离线回复模版列表-修改关键词
export function editkeyword(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcKeyWord/edit',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//获取所有客服+自动
export function getallacclist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcCompanyDevice/drop',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//分配客服
export function setsharekf(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcCompanyDevice/allocation',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//营销数据列表
export function getrecordlist(url,data) {
  return axios({
    method: 'get',
    url: url+'/work/bcPushRecord/list',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    }
  })
}

//小程序导出
export function exportweapp(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcPushRecord/export',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//查看全部小程序导出
export function checkexportweapp(url,data) {
  return axios({
    method: 'post',
    url: url+'/work/bcPushRecord/exportAll',
    params:data,
    headers: {
      'token': $cookies.get("fanstoken")
    },
  })
}

//按加粉日期打标：当前列表筛选条件下命中数量
export function newtagcount(data) {
  return axios({
    method: 'post',
    url: '/api/external-contact/plat/count',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//打标任务-创建
export function newtagtaskcreate(data) {
  return axios({
    method: 'post',
    url: '/api/tag-task/create',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//打标任务-列表
export function newtagtasklist(data) {
  return axios({
    method: 'post',
    url: '/api/tag-task/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//打标任务-详情
export function newtagtaskdetail(data) {
  return axios({
    method: 'get',
    url: '/api/tag-task/detail',
    params:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

// ==================== 信息收集码 ====================
//收集码列表（含统计）
export function newinfolist(data) {
  return axios({
    method: 'get',
    url: '/api/info_collect/code/list',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//打标任务-重试失败
export function newtagtaskretry(data) {
  return axios({
    method: 'post',
    url: '/api/tag-task/retry-failed',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//收集码详情
export function newinfodetail(data) {
  return axios({
    method: 'get',
    url: '/api/info_collect/code/detail',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//收集码表单选项（企微主体 + 坐席）
export function newinfooptions(data) {
  return axios({
    method: 'get',
    url: '/api/info_collect/code/form-options',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//新建收集码
export function newinfocreate(data) {
  return axios({
    method: 'post',
    url: '/api/info_collect/code/create',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//打标任务-导出失败
export function newtagtaskexport(data) {
  return axios({
    method: 'post',
    url: '/api/tag-task/export-failed',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//编辑收集码
export function newinfoupdate(data) {
  return axios({
    method: 'post',
    url: '/api/info_collect/code/update',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//自动打标规则-列表
export function newtagrulelist(data) {
  return axios({
    method: 'post',
    url: '/api/tag-rule/list',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//启停收集码
export function newinfostatus(data) {
  return axios({
    method: 'post',
    url: '/api/info_collect/code/status',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//自动打标规则-保存
export function newtagrulesave(data) {
  return axios({
    method: 'post',
    url: '/api/tag-rule/save',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//删除收集码
export function newinfodelete(data) {
  return axios({
    method: 'post',
    url: '/api/info_collect/code/delete',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//自动打标规则-启用/暂停
export function newtagruletoggle(data) {
  return axios({
    method: 'post',
    url: '/api/tag-rule/toggle',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//填写记录列表
export function newinforecordlist(data) {
  return axios({
    method: 'get',
    url: '/api/info_collect/record/list',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//填写记录详情
export function newinforecorddetail(data) {
  return axios({
    method: 'get',
    url: '/api/info_collect/record/detail',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//填写记录重试建码
export function newinforetry(data) {
  return axios({
    method: 'post',
    url: '/api/info_collect/record/retry',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//自动打标规则-删除
export function newtagruledelete(data) {
  return axios({
    method: 'post',
    url: '/api/tag-rule/delete',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//H5-收集页配置
export function newopenh5config(data) {
  return axios({
    method: 'get',
    url: '/api/open/info_collect/config',
    params: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//H5-提交填写
export function newopenh5submit(data) {
  return axios({
    method: 'post',
    url: '/api/open/info_collect/submit',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}

//自动打标规则-立即执行
export function newtagrulerun(data) {
  return axios({
    method: 'post',
    url: '/api/tag-rule/run-now',
    data:data,
    headers: {
      'Authorization': 'Bearer ' +  $cookies.get("fanstoken")
    }
  })
}

//H5-建码失败重试
export function newopenh5retry(data) {
  return axios({
    method: 'post',
    url: '/api/open/info_collect/retry',
    data: data,
    headers: {
      'Authorization': 'Bearer ' + $cookies.get("fanstoken")
    }
  })
}


